import React, {useState} from 'react';
import AddIcon from '@mui/icons-material/Add';

import {useUserContext} from "../../../contexts/UserContext";
import {CreateLeadItem} from "./CreateLeadItem";
import {useDebounce} from "@uidotdev/usehooks";
import useDidMountEffect from "../../../hooks/useDidMountEffect";
import Stack from "@mui/material/Stack";
import Tooltip from "@mui/material/Tooltip";
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import {NewColumnModal} from "../NewColumnModal";
import {ConfirmationModal} from "../../../components/ConfirmationModal";
import {useModalsStore} from "../../../stores/modalsStore";

export const CustomLeadColumnHeader = ({ column, columnNum }) => {
    const { profileState, setProfileStateWithUpdate } = useUserContext()
    const openModal = useModalsStore((state) => state.openModal)
    const [columnName, setColumnName] = useState(column['display_name'])
    const debouncedColumn = useDebounce(columnName, 300)

    useDidMountEffect(function updateLeadColumnHeader() {
        const newLeadColumns = structuredClone(profileState.lead_columns)
        newLeadColumns[columnNum]["display_name"] = columnName

        setProfileStateWithUpdate({...profileState, lead_columns: newLeadColumns})
    }, [debouncedColumn])

    const deleteColumn = () => {
        const newLeadColumns = structuredClone(profileState.lead_columns)
        delete newLeadColumns[columnNum]
        setProfileStateWithUpdate({...profileState, lead_columns: newLeadColumns})
    }

    const description = `Are you sure you want to delete column ${columnName}? \n Deleting
    this column will also delete all the associated data.`

    const numberOfColumns = Object.keys(profileState.lead_columns).length

    const colWidth = 20 / numberOfColumns

    return (
        <th
            key={columnNum}
            width={`${colWidth}%`}
            className={'crm_table_header custom-column'}
        >
            <input
                className=""
                type="text"
                value={columnName}
                onChange={(e) => setColumnName(e.target.value)}
            />
            <Tooltip title="Delete Column" arrow placement={'top'}>
                <DeleteForeverIcon onClick={() => {
                    openModal({
                        element: ConfirmationModal,
                        id: "ConfirmationModal",
                        props: {
                            onConfirm: deleteColumn,
                            header: `Delete column "${columnName}"`,
                            description: description,
                        }
                    })
                }}/>
            </Tooltip>
        </th>
    )

}

export const LeadsTableHeaders = () => {
    const { profileState, setProfileStateWithUpdate } = useUserContext()
    const openModal = useModalsStore((state) => state.openModal)
    const columns = profileState.lead_columns
    const lead_columns = profileState.lead_columns

    const sortedColumns = Object.keys(columns).sort((a, b) => a - b)

    const addColumn = (name) => {
        let highestOrderNum = 0
        Object.values(columns).map(col => {
            if (col.order > highestOrderNum) {
                highestOrderNum = col.order
            }
        })
        const newId = new Date().getTime()
        const newOrderNum = highestOrderNum + 1
        const newColumn = {
            order: newOrderNum,
            name: name,
            display_name: name
        }

        setProfileStateWithUpdate(
            {
                ...profileState,
                lead_columns: {...lead_columns, [newId]: newColumn}
            }
        )
    }

    return (
        <thead>
            <tr className={"leads_table_row crm-header-row"}>
                <th
                    width={'5%'}
                    key='Name' className={'crm_table_header'}>
                    Name
                </th>

                <th
                    width={'3%'}
                    key='Phone' className={'crm_table_header'}>
                    Phone
                </th>
                <th
                    width={'5%'}
                    key='Email' className={'crm_table_header'}>
                    Email
                </th>

                {
                    sortedColumns.map((columnNum) => (
                        <CustomLeadColumnHeader
                            key={columnNum}
                            column={columns[columnNum]}
                            columnNum={columnNum}/>
                        )
                    )
                }

                <th
                    width={'1%'}
                    key='My Quotes' className={'crm_table_header'}>
                    My Quotes
                </th>

                <th
                    width={'1%'}
                    key='Actions'
                    className={'crm_table_header actions'}
                >
                    <Stack
                        direction="row"
                        justifyContent="space-between"
                        alignItems="center"
                        style={{
                            height: '100%'
                        }}
                    >
                        <span>Actions</span>

                        <Tooltip title="Add Column" arrow placement={'top'}>
                            <th
                                onClick={() => {
                                    openModal({
                                        element: NewColumnModal,
                                        id: "NewColumnModal",
                                        props: {
                                            onSave: (name) => addColumn(name),
                                            columns: columns
                                        }
                                    })
                                }}
                                className={'add-column'}
                            >
                                <AddIcon/>
                            </th>
                        </Tooltip>
                    </Stack>
                </th>


            </tr>

            <CreateLeadItem/>
        </thead>
    )
}